// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__1-S83","loader-spin":"styles_loader-spin__3zx_W","loader-dash":"styles_loader-dash__3TH0G"};